/**
 * Texte de la recherche ⌘K. Les libellés de modules et d'actions se filtrent
 * côté client : sans accent ni casse, avec la ligature « œ » dépliée
 * (« oeuvre » doit trouver « Œuvres »), et chaque mot saisi doit s'y trouver.
 */

/** Longueur maximale de `q` acceptée par l'API des listes (schémas `max(200)`). */
export const LONGUEUR_MAX_RECHERCHE = 200;

export function aplatir(texte: string): string {
  return texte
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/œ/gi, 'oe')
    .replace(/æ/gi, 'ae')
    .toLowerCase();
}

export function correspondA(libelle: string, saisie: string): boolean {
  const mots = aplatir(saisie).split(/\s+/).filter(Boolean);
  if (mots.length === 0) return true;
  const cible = aplatir(libelle);
  return mots.every((mot) => cible.includes(mot));
}

/** La saisie telle qu'on l'envoie à l'API : blancs repliés, bornée. */
export function saisieBornee(saisie: string): string {
  return saisie.replace(/\s+/g, ' ').trim().slice(0, LONGUEUR_MAX_RECHERCHE).trim();
}
